import {
  Megaphone,
  Search,
  MousePointerClick,
  Target,
  PenTool,
  MonitorSmartphone,
  TrendingUp,
  MessagesSquare,
  Sparkles,
  SlidersHorizontal,
  Headset,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", href: "/#home" },
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services" },
  { label: "Contact", href: "/#contact" },
];

export const SERVICES = [
  {
    icon: Megaphone,
    title: "Social Media Management",
    description:
      "Consistent, on-brand presence that turns followers into customers.",
    features: ["Content planning", "Content scheduling", "Community management", "Monthly reporting"],
  },
  {
    icon: Search,
    title: "Search Engine Optimization",
    description:
      "Rank higher, get found first, and own your search presence.",
    features: ["On-page SEO", "Keyword research", "Technical SEO", "Local SEO"],
  },
  {
    icon: MousePointerClick,
    title: "Google Ads (PPC)",
    description:
      "Precision-targeted campaigns engineered for qualified leads.",
    features: ["Search campaigns", "Display campaigns", "Lead generation", "Conversion optimization"],
  },
  {
    icon: Target,
    title: "Meta Ads",
    description:
      "Facebook and Instagram advertising that converts attention into revenue.",
    features: ["Facebook Ads", "Instagram Ads", "Retargeting", "Audience targeting"],
  },
  {
    icon: PenTool,
    title: "Content Creation",
    description:
      "Scroll-stopping creative crafted to elevate your brand.",
    features: ["Graphic design", "Marketing copy", "Reels", "Short-form content"],
  },
  {
    icon: MonitorSmartphone,
    title: "Website Design",
    description:
      "Elegant, high-performing websites built to convert visitors.",
    features: ["Landing pages", "Business websites", "UI/UX improvements", "Website optimization"],
  },
];

export const WHY_US = [
  {
    icon: TrendingUp,
    title: "Results-Driven Strategies",
    description: "Every campaign is designed around measurable growth.",
  },
  {
    icon: MessagesSquare,
    title: "Transparent Communication",
    description: "No hidden fees or confusing reports.",
  },
  {
    icon: Sparkles,
    title: "Creative + Performance",
    description: "Beautiful branding combined with marketing that converts.",
  },
  {
    icon: SlidersHorizontal,
    title: "Tailored Solutions",
    description: "Every business receives a customized strategy.",
  },
];

export const TRUST_INDICATORS = [
  {
    icon: TrendingUp,
    title: "Results-Driven",
    description: "Every campaign is measured against real business outcomes.",
  },
  {
    icon: MessagesSquare,
    title: "Transparent Communication",
    description: "Clear reporting and honest updates at every stage.",
  },
  {
    icon: SlidersHorizontal,
    title: "Custom Strategies",
    description: "No templates — every plan is built around your business.",
  },
  {
    icon: Headset,
    title: "Dedicated Support",
    description: "A responsive team that knows your brand and your goals.",
  },
];

export const PROCESS = [
  { num: "01", title: "Discovery Call", description: "Understanding your business goals." },
  { num: "02", title: "Strategy", description: "Building a personalized marketing plan." },
  { num: "03", title: "Launch", description: "Campaign execution." },
  { num: "04", title: "Optimization", description: "Continuous improvements using real data." },
];

export const FAQS = [
  {
    q: "What services do you offer?",
    a: "We offer social media management, SEO, Google Ads (PPC), Meta Ads, content creation, and website design — combined into one tailored strategy built around your goals.",
  },
  {
    q: "How long before seeing results?",
    a: "Paid advertising typically shows traction within the first few weeks. SEO and organic growth compound over three to six months. You receive clear monthly reports throughout.",
  },
  {
    q: "Do you work with startups?",
    a: "Absolutely. We build tailored packages for startups and growing businesses, scaled to your stage and budget.",
  },
  {
    q: "Do you offer custom packages?",
    a: "Yes. Every engagement is scoped individually after a discovery call, so you only invest in what moves your business forward.",
  },
  {
    q: "How do we get started?",
    a: "Book a free consultation. We will learn about your goals, review your current presence, and present a personalized strategy — no obligation.",
  },
];
